module.exports = __webpack_public_path__ + "media/Components/fonts/boldPTSans-4597bd693b40f5010303ccffc8914cc6.ttf";